import { Middleware } from 'redux'
import { AddMessage, ChatStarted, ClearTyping, CloseChat, DisconnectUser, LeaveChat, MarkAsRead, PostMessage, RequestChat, SetAvailable, SetRequesting, SetRequests, SetUsersOnline, SetVisibility, StaffJoined, ToggleChat, TypingMessage } from '../reducers/ChatSlice';
import { HubConnectionBuilder, HubConnectionState } from '@microsoft/signalr';
import { IChatMessage } from '../../types/IChatMessage';
import { RootState } from '../store';
import { IChat } from '../../types/IChat';
import { ChatApi } from '../api/ChatApi';
import IChatUser from '../../types/IChatUser';
import { ChatVisibility } from '../../types/ChatVisibility';
import { ThunkDispatch } from '@reduxjs/toolkit';


//let newConnection: HubConnection;
//const [invalidateApiCache] = ChatApi.useInvalidateChatCacheMutation();
//<ThunkDispatch<any, any, AnyAction>>
const SignalRMiddleware: Middleware = ({ getState, dispatch }) => {
    let connection;
    return next => action => {

        var token = (getState() as RootState).auth?.user?.access_token;
        var profile = (getState() as RootState).chat.profile;
        //var token = (getState() as RootState).auth.user
        //console.log('SignalRMiddleware start, profile =', profile, "SSIChat:", profile?.Features?.SSIChat, "Chat:", profile?.Features?.Chat);
        if (!connection && token && (profile?.Features?.SSIChat || profile?.Features?.Chat)) {
            console.log('new HubConnectionBuilder in SignalRMiddleware', process.env.REACT_APP_CHAT_HUB_URL);


            connection = new HubConnectionBuilder()
                .withUrl(process.env.REACT_APP_CHAT_HUB_URL, { accessTokenFactory: () => token })
                .withAutomaticReconnect()
                .build();

            connection.onreconnected(e => { console.log('ChatHub onreconnected', connection?.state) });
            connection.onclose(e => { console.log('ChatHub onclose', connection?.state) });

            //console.log('starting:', connection)
            connection.start().catch(e => console.error('No SignalR connection could be established', e));



            ///Chat has been updated - probably last ready date
            connection.on('ChatUpdated', (chat: IChat) => {
                console.log('ChatUpdated in SignalRMiddleware', chat);
                //if (chat)
                //store.dispatch(SetChats([chat]))

                //invalidate the Chat API cache
                //await invalidateApiCache();
                dispatch(ChatApi.util.invalidateTags(["Chat", "Chats", "ChatMessages"]));
                console.log('done invalidateApiCache');
            });

            connection.on('UserConnected', (users: IChatUser[]) => {
                //console.log('UserConnected in SignalRMiddleware', users);

                dispatch(SetUsersOnline(users))
            });

            connection.on('ReceiveMessage', (message: IChatMessage) => {
                const lastRead = new Date(message.Created).toISOString();
                console.log('ReceiveMessage in SignalRMiddleware', message, lastRead);


                //Api Update function
                const updateFunc = (draft: IChat[]) => {
                    var found = draft.find(c => c?.ConversationId === message?.ConversationId);

                    console.log('ChatApi.util.updateQueryData.getChats', found);

                    if (found) {
                        found.Last_Message = message.Text;
                        found.Last_Message_Contact_Id = message.Contact_Id;
                        found.Last_Message_Date = lastRead;
                        found.Staff_Last_Read = message.Contact_Id === found.StaffContact_Id ? lastRead : found.Staff_Last_Read;
                        found.EndUser_Last_Read = message.Contact_Id === found.EndUserContact_Id ? lastRead : found.EndUser_Last_Read;
                    }
                }

                //Set the last message in the message list (feed)
                (dispatch as ThunkDispatch<any, any, any>)(ChatApi.util.updateQueryData('getChats', undefined, updateFunc));
                (dispatch as ThunkDispatch<any, any, any>)(ChatApi.util.updateQueryData('getChats', true, updateFunc));
                (dispatch as ThunkDispatch<any, any, any>)(ChatApi.util.updateQueryData('getChats', false, updateFunc));
                (dispatch as ThunkDispatch<any, any, any>)(ChatApi.util.updateQueryData('getChat', message?.ConversationId, (draft: IChat) => {
                    draft.Last_Message = message.Text;
                    draft.Last_Message_Contact_Id = message.Contact_Id;
                    draft.Last_Message_Date = lastRead;
                    draft.Staff_Last_Read = message.Contact_Id === draft.StaffContact_Id ? lastRead : draft.Staff_Last_Read;
                    draft.EndUser_Last_Read = message.Contact_Id === draft.EndUserContact_Id ? lastRead : draft.EndUser_Last_Read;
                }));

                dispatch(AddMessage(message));

            });

            //Recieve a list of chat requests
            connection.on('Requests', (requests: IChat[]) => {
                console.log('Requests in SignalRMiddleware', requests);

                dispatch(SetRequests(requests))
            });

            //The current user has been force disconnected.
            connection.on('ForceDisconnect', () => {
                console.log('ForceDisconnect in SignalRMiddleware');

                dispatch(SetVisibility(ChatVisibility.Offline));

                //invalidate the Chat API cache
                dispatch(ChatApi.util.invalidateTags(["ChatMyVisibility"]));
            });

            //Recieve a list of chat requests
            connection.on('StartChat', (newChat: IChat) => {
                console.log('StartChat in SignalRMiddleware', newChat);
                //Stop progress indicator
                dispatch(SetRequesting(false));
                //Forces API refetch
                dispatch(ChatApi.util.invalidateTags(["Chat", "Chats", "ChatPins"]));
                //store.dispatch(SetChats([newChat]));dotnet 
            });
            connection.on('ChatAvailable', (available: boolean) => {
                console.log('ChatAvailable in SignalRMiddleware', available);
                //Stop progress indicator
                dispatch(SetAvailable(available));
            });

            //Someone else is typing a message
            let typingTimer = null;
            connection.on('IsTyping', (Id: number, conversationId: string, displayName: string) => {
                console.log('Someone else IsTyping', Id, displayName, typingTimer)
                if (!typingTimer) {
                    const typeingMessage = { Id: 0, Is_Typing: true, Chat_Id: Id, ConversationId: conversationId, Text: `${displayName} is typing...`, Is_Event: true } as IChatMessage
                    dispatch(AddMessage(typeingMessage));
                }
                //Setup a timeout to remove the message
                typingTimer && clearTimeout(typingTimer);
                typingTimer = setTimeout(() => {
                    dispatch(ClearTyping(conversationId))
                    typingTimer = null;
                }, 8000);
            });


            //Auto PING process to keep user's precense alive
            window.setInterval(() => {
                if (connection?.state === HubConnectionState.Connected) {
                    console.log('Ping!', connection?.state)
                    connection.send('Ping');
                }
            }, 30000);

        }

        //Post new message
        if (SetVisibility.match(action)) {
            console.log('SetVisibility', connection?.state);
            try {
                console.log('stopping', connection?.state);
                connection.stop().then(() => {
                    console.log('stopped', connection?.state);
                    console.log('restarting');
                    connection.start().then(() => {
                        console.log('restarted', connection?.state);
                    });
                });

            }
            catch (e) {
                console.error(e);
            }

        }

        //Adds a message to the Redux API Cache for instant view (optamistic update)
        if (AddMessage.match(action)) {
            (dispatch as ThunkDispatch<any, any, any>)(
                ChatApi.util.updateQueryData('getMessages', action.payload.ConversationId, (draft: IChatMessage[]) => {
                    console.log('AddMessage', draft.length, action.payload.Id);
                    //clear typing message
                    var isTyping = draft.find(m => m.Is_Typing);
                    if (isTyping) draft.splice(draft.indexOf(isTyping), 1);

                    //Add to messages                    
                    var exists = draft.find(m => m.Id === 0 && m.Text === action.payload.Text);
                    if (exists) draft.splice(draft.indexOf(exists), 1);

                    draft.push(action.payload);
                }));
        }

        //Clear any 'typing' messages in the Redux API cache
        if (ClearTyping.match(action)) {
            (dispatch as ThunkDispatch<any, any, any>)(
                ChatApi.util.updateQueryData('getMessages', action.payload, (draft: IChatMessage[]) => {
                    console.log('ClearTyping', draft.length);
                    var isTyping = draft.find(m => m.Is_Typing);
                    if (isTyping) draft.splice(draft.indexOf(isTyping), 1);
                    console.log('ClearTyping after', draft.length, isTyping);
                }));
        }

        //Toggle the chat expanded or collapsed.
        if (ToggleChat.match(action)) {
            (dispatch as ThunkDispatch<any, any, any>)(
                ChatApi.util.updateQueryData('getChat', action.payload.conversationId, (draft: IChat) => {
                    if (action.payload.uId == draft.Staff_Uid) draft.Staff_Expanded = action.payload.expanded;
                    if (action.payload.uId == draft.EndUser_Uid) draft.EndUser_Expanded = action.payload.expanded;
                }));

            if (connection?.state === HubConnectionState.Connected) {
                try {
                    connection.send('ToggleChat', action.payload);
                }
                catch (e) {
                    console.error(e);
                }
            }
            else {
                alert('No connection to server yet.');
            }
        }

        //Post new message
        if (PostMessage.match(action)) {
            console.log('PostMessage', connection?.state);
            if (connection?.state === HubConnectionState.Connected) {
                try {
                    connection.send('SendMessage', action.payload);
                }
                catch (e) {
                    console.error(e);
                }
            }
            else {
                alert('No connection to server yet.');
            }
            return;
        }

        //Post new message
        if (DisconnectUser.match(action)) {
            console.log('DisconnectUser', connection?.state);
            if (connection?.state === HubConnectionState.Connected) {
                try {
                    connection.send('DisconnectUser', action.payload);
                }
                catch (e) {
                    console.error(e);
                }
            }
            else {
                alert('No connection to server yet.');
            }
            return;
        }

        //Post new message
        if (StaffJoined.match(action)) {
            console.log('StaffJoined', connection?.state);
            if (connection?.state === HubConnectionState.Connected) {
                try {
                    connection.send('StaffJoined', action.payload);
                }
                catch (e) {
                    console.error(e);
                }
            }
            else {
                alert('No connection to server yet.');
            }
            return;
        }

        //End user sends a chat request
        if (RequestChat.match(action)) {
            console.log('RequestChat in Middleware', connection?.state);
            if (connection?.state === HubConnectionState.Connected) {
                try {
                    connection.send('RequestChat', action.payload);
                }
                catch (e) {
                    console.error(e);
                }
            }
            else {
                alert('No connection to server yet.');
            }

            return;
        }

        //End user sends a chat request
        if (LeaveChat.match(action)) {
            console.log('LeaveChat in Middleware', connection?.state);
            if (connection?.state === HubConnectionState.Connected) {
                try {
                    connection.send('LeftChat', action.payload);
                }
                catch (e) {
                    console.error(e);
                }
            }
            else {
                alert('No connection to server yet.');
            }

            return;
        }

        //Staff Closes a chat
        if (CloseChat.match(action)) {
            console.log('CloseChat in Middleware', connection?.state);
            if (connection?.state === HubConnectionState.Connected) {
                try {
                    connection.send('ClosedChat', action.payload);
                }
                catch (e) {
                    console.error(e);
                }
            }
            else {
                alert('No connection to server yet.');
            }

            return;
        }

        //User is typing a message
        if (TypingMessage.match(action)) {
            console.log('TypingMessage in Middleware', connection?.state);
            if (connection?.state === HubConnectionState.Connected) {
                try {
                    connection.send('Typing', action.payload);
                }
                catch (e) {
                    console.error(e);
                }
            }
            else {
                alert('No connection to server yet.');
            }

            return;
        }

        //Has been started by the user
        if (ChatStarted.match(action)) {
            console.log('ChatStarted in Middleware', connection?.state);
            if (connection?.state === HubConnectionState.Connected) {
                try {
                    connection.send('ChatStarted', action.payload);
                }
                catch (e) {
                    console.error(e);
                }
            }
            else {
                alert('No connection to server yet.');
            }

            return;
        }

        if (MarkAsRead.match(action)) {
            console.log('MarkAsRead in Middleware', action.payload, connection?.state);
            if (connection?.state === HubConnectionState.Connected) {
                try {
                    connection.send('MarkAsRead', action.payload);
                }
                catch (e) {
                    console.error(e);
                }
            }
            //else {
            //alert('No connection to server yet.');
            // }
        } else {
            next(action);
        }
    }
}

export default SignalRMiddleware;